'use client';

import { useTrackingUserParamsStore } from '@/modules/userTrackingParams';
import { useGetCommonStore } from '@/store';
import { getCookieGeoCountry } from './helpers';

export const useCookieGeoCountry = () => {
  const useCommonStore = useGetCommonStore();
  const countryCode = useCommonStore.use.countryCode();
  const hasStag = useTrackingUserParamsStore((state) => !!state.stag);

  return getCookieGeoCountry(countryCode, hasStag);
};
